import { FloatingLabel, Label } from "@progress/kendo-react-labels";
import * as React from "react";
import { PropsWithChildren } from "react";

const FormLabel: React.FC<
  {
    floating?: boolean;
    floatLabel?: string;
    id: string;
    editorId: string;
    editorValid: boolean;
    editorDisabled: boolean;
    label?: string;
    value?: string;
    placeholder?: string;
    optional?: boolean;
  } & PropsWithChildren
> = ({
  children,
  floating,
  id,
  editorValid,
  editorDisabled,
  editorId,
  label,
  value,
  placeholder,
  floatLabel,
  optional,
}) => {
  if (floating) {
    return (
      <FloatingLabel
        id={id}
        editorId={editorId}
        editorValid={editorValid}
        editorDisabled={editorDisabled}
        editorValue={value}
        label={value ? floatLabel || label : label}
        editorPlaceholder={placeholder}
        optional={optional}
      >
        {children}
      </FloatingLabel>
    );
  }
  return (
    <>
      <Label
        id={id}
        editorId={editorId}
        editorValid={editorValid}
        editorDisabled={editorDisabled}
      >
        {label}
      </Label>
      {children}
    </>
  );
};

export default FormLabel;
